import { useFlash } from 'contexts/flash';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { resetPasswordSchema } from 'utils/validate';
import { resetPassword } from 'services/auth';
type ResetPassword = {
  password: string;
  confirmPassword: string;
};
export const useInjection = () => {
  const { setFlash } = useFlash();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<ResetPassword>({ resolver: yupResolver(resetPasswordSchema) });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const postResetPassword = useCallback(
    async (data: ResetPassword) => {
      const code = searchParams.get('code');
      const platform = searchParams.get('platform');
      if (!code) return;
      await resetPassword({ code: code, password: data.password });
      setFlash({
        type: 'success',
        message: 'Your password has been successfully reset. Please log in again.'
      });
      navigate(`/reset-password/success?platform=${platform}`);
    },
    [navigate, setFlash, searchParams]
  );

  const navigateLogin = () => navigate('/login');

  const { asyncCallback: handleSubmitForm } = useAsyncCallback(postResetPassword, []);
  return {
    handleSubmitForm,
    handleSubmit,
    register,
    errors,
    navigateLogin,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword
  };
};
